import React from "react";

const Stepper = ({ steps = [], currentStep = 1 }) => {
	return (
		<div className="w-full flex justify-center">
			<ol className="flex items-center gap-8 text-sm font-medium text-gray-700 sm:text-base">
				{steps.map((step, index) => {
					const stepNumber = index + 1;
					const isCompleted = currentStep > stepNumber;
					const isActive = currentStep === stepNumber;
					const isLast = stepNumber === steps.length;

					return (
						<li
							key={index}
							className={[
								"flex items-center",
								!isLast
									? "sm:after:content-[''] after:h-[2px] after:bg-gray-300 after:hidden sm:after:block after:w-12 sm:after:w-20 xl:after:w-32 after:mx-6"
									: "",
								isCompleted || isActive ? "text-primary" : "text-gray-400",
							].join(" ")}
						>
							<span className="flex items-center whitespace-nowrap">
								<span
									className={[
										"w-6 h-6 flex-none flex items-center justify-center rounded-full text-[10px] font-medium me-2",
										isCompleted
											? "bg-primary text-white"
											: isActive
											? "border-2 border-primary text-primary"
											: "border-2 border-gray-300 text-gray-400",
									].join(" ")}
								>
									{isCompleted ? "✓" : stepNumber}
								</span>

								{step}
							</span>
						</li>
					);
				})}
			</ol>
		</div>
	);
};

export default Stepper;
